import { AxiosPromise } from 'axios';
import { urlHelper } from 'src/app/helpers';
import {
  GetNoteDataQueryType,
  NoteLookupResultType,
  TakeNoteDataType,
} from 'src/app/services/notes/notes.service.type';
import { axios } from 'src/app/utils';
import { finalUrlsConfig } from 'src/configs/url.config';

export const lookup = (customerId?: string): AxiosPromise<NoteLookupResultType> => {
  const query: GetNoteDataQueryType = {};
  if (customerId) {
    query.customerId = customerId;
  }
  return axios.get(urlHelper.addQueryParameters(query, finalUrlsConfig().notes.lookup));
};

export const create = (data: TakeNoteDataType): AxiosPromise<NoteLookupResultType> => {
  return axios.post(finalUrlsConfig().notes.create, data);
};

// export const update = (data: updateNoteDataType): AxiosPromise<noteLookupResultType> => {
//     return axios.patch(finalUrlsConfig().notes.create,data)
// }
export default {
  lookup,
  create,
  // update
};
